import { EVENT_STATUS_CLOSED } from '@ogsnetwork/opp-api-lib';
import { fetchBets, fetchFantasyEvents, fetchSelections, makeTicketsOrderedByPositionSelector } from '@ogsnetwork/opp-redux-lib';
import { useEffect, useMemo } from 'react';
import { useAppDispatch, useAppSelector } from '../index';
const LIVE_EVENT_POLLING_INTERVAL = 60 * 1000;
export function useLivePropBet(props) {
    const dispatch = useAppDispatch();
    const bets = useAppSelector((state) => { var _a; return ((_a = state.bets.byEventGameId[props.event.externalId]) !== null && _a !== void 0 ? _a : []).map((betId) => state.bets.byId[betId]); });
    const selectionsByBetId = useAppSelector((state) => {
        var _a;
        const selectionsByTicketId = state.selections.byTicketId;
        const selectionsById = state.selections.byId;
        const selections = ((_a = selectionsByTicketId[props.ticket.id]) !== null && _a !== void 0 ? _a : []).map((selectionId) => selectionsById[selectionId]);
        return selections.reduce((reducerSelectionsById, selection) => {
            if (selection.betId) {
                reducerSelectionsById[selection.betId] = selection;
            }
            return reducerSelectionsById;
        }, {});
    });
    const ticketsOrderedByPositionSelector = useMemo(makeTicketsOrderedByPositionSelector, []);
    const orderedTicketsForEvent = useAppSelector((state) => ticketsOrderedByPositionSelector(state, { eventId: props.event.id }));
    function dispatchFetchFantasyEvents() {
        dispatch(fetchFantasyEvents({
            eventId: props.event.id,
            data: { ticketIds: [props.ticket.id] }
        }));
    }
    function dispatchFetchBet() {
        dispatch(fetchBets(parseInt(props.event.externalId, 10)));
    }
    function dispatchFetchSelections() {
        dispatch(fetchSelections(props.ticket.id));
    }
    function refresh() {
        dispatchFetchFantasyEvents();
        dispatchFetchBet();
        dispatchFetchSelections();
    }
    useEffect(() => {
        if (props.event.status === EVENT_STATUS_CLOSED) {
            const liveEventPollingInterval = setInterval(() => {
                dispatchFetchFantasyEvents();
                dispatchFetchBet();
                dispatchFetchSelections();
            }, LIVE_EVENT_POLLING_INTERVAL);
            return () => {
                clearInterval(liveEventPollingInterval);
            };
        }
    }, [props.event.status]);
    useEffect(() => {
        dispatchFetchFantasyEvents();
        dispatchFetchBet();
    }, []);
    return {
        bets,
        selectionsByBetId,
        orderedTicketsForEvent,
        refresh
    };
}
